<template>
  <div class="content">
    <PageHeader title="WhatsApp" />
    <section class="page-content container-fluid">
      <div class="row">
        <div class="col-sm-12" v-if="fetched">
          <div class="row">
            <div class="col-sm-6">
              <div class="card">
                <div class="card-content">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-10">
                        <h4 class="card-title"><i class="mr-2 fab fa-whatsapp fa-fw"></i> Ativação Incorporada</h4>
                        <p class="card-text">Por meio deste link seguirão o fluxo de ativação por meio do Facebook. Ative a sua conta em menos de 10 minutos e conclua o processo de verificação mais tarde.</p>
                        <a class="btn btn-primary"  href="https://hub.360dialog.com/lp/whatsapp/YZKzG7PA" target="_blank" v-if="!client.active && client.status != 'waiting'">Solicitar Acesso</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="card-content">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-10">
                        <h4 class="card-title"><i class="mr-2 fab fa-whatsapp fa-fw"></i>Ativação Clássica</h4>
                        <p class="card-text">Os envios por meio deste formulário seguirão o fluxo de ativação completa. As informações devem ser completamente verificadas antes de acessar os recursos de mensagem.</p>
                        <a class="btn btn-primary"  href="https://hub.360dialog.com/lp/submit-waba/YZKzG7PA" target="_blank" v-if="!client.active && client.status != 'waiting'">Solicitar Acesso</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="card-content">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-10">
                        <h4 class="card-title"><i class="mr-2 fab fa-whatsapp fa-fw"></i>Portabilidade de número</h4>
                        <p class="card-text">Crie uma conta por meio da portabilidade de um número de outro BSP.</p>
                        <a class="btn btn-primary"  href="https://hub.360dialog.com/lp/migrate/YZKzG7PA" target="_blank" v-if="!client.active && client.status != 'waiting'">Solicitar Portabilidade</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import PageHeader from '@/components/PageHeader.vue';
import WhatsAppService from '@/services/whatsapp.service';
import Swal from 'sweetalert2';

export default {
  name: 'MailDashboard',
  components: {
    PageHeader,
  },
  data() {
    return {
      fetched: false,
      fetchedItens: false,
      client: {},
      templates: [],
      messages: [],
      campaigns: [],
      tab: 'messages',
      pages: 1,
      lists: [],
      form: {
        page: 1,
        created_at: {},
      },
      options: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Otu',
            'Nov',
            'Dez',
          ],
        },
      },
    };
  },
  mounted() {
  },
  created() {
    this.fetch();
    this.changeDate();
    this.$root.$on('client.submit', this.clientMake);
  },
  methods: {
    clientMake(client) {
      this.client = client;
      console.log('Cliente criado');
      console.log(client);
    },
    changeDate(date) {
      if (date) {
        this.beginDate = moment(date[0], 'DD/MM/YYYY').format(
          'YYYY-MM-DD 00:00:00',
        );
        this.endDate = moment(date[1], 'DD/MM/YYYY').format(
          'YYYY-MM-DD 23:59:59',
        );
      } else {
        this.beginDate = moment().format('YYYY-MM-DD 00:00:00');
        this.endDate = moment().format('YYYY-MM-DD 23:59:59');
      }
      this.form.created_at.gte = this.beginDate;
      this.form.created_at.lte = this.endDate;
    },
    fetch() {
      Promise.all([
        WhatsAppService.getClient(),
      ])
        .then(
          (responses) => {
            console.log(responses);
            this.client = responses[0].data;
            this.fetched = true;
            this.form.client_id = this.client.id;
          },
          (error) => {
            this.content = error;
          },
        )
        .finally(() => {
          this.fetched = true;
        });
    },
    deleteTemplate(id) {
      Swal.fire({
        title: this.$t('generic-str.r-sure'),
        text:
          this.$t('template-component.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.fetchedItens = false;
          Promise.all([
            WhatsAppService.deleteTemplate(id, this.form),
          ])
            .then(
              (responses) => {
                console.log(responses);
                this.fetchTemplates();
              },
              (error) => {
                this.content = error;
              },
            )
            .finally(() => {
              this.fetchedItens = true;
            });
        }
      });
    },
    fetchTemplates() {
      this.fetchedItens = false;
      Promise.all([
        WhatsAppService.getTemplates(this.form),
      ])
        .then(
          (responses) => {
            console.log('Templates');
            console.log(responses[0]);
            if (responses[0].data.data) {
              this.templates = responses[0].data.data;
            }
            this.fetchedItens = true;
          },
          (error) => {
            this.content = error;
          },
        )
        .finally(() => {
          this.fetchedItens = true;
        });
    },
    fetchMessages() {
      this.fetchedItens = false;
      Promise.all([
        WhatsAppService.getMessages(this.form),
      ])
        .then(
          (responses) => {
            console.log(responses);
            if (responses[0].data.data) {
              this.messages = responses[0].data.data;
            }
            this.fetchedItens = true;
          },
          (error) => {
            this.content = error;
          },
        )
        .finally(() => {
          this.fetchedItens = true;
        });
    },
    tabChange(t) {
      this.tab = t;
    },
    callModal(id) {
      this.$root.$emit('show.modal', id, { client_id: this.client.id });
    },
  },
};
</script>

<style scoped lang="scss">
.btn i {
  line-height: 1;
  color: inherit;
}
</style>
